<template>
    <Default-Layout>
        <div class="container profile">
            <div class="row">
                <div class="col-12">
                    <!--   <div class="prof_title">
                  <h4>Privileges</h4>
                  <p style="text-align:center"> Create privileges for the management of your organizations.</p>
                </div> -->
                    <div class="card">
                        <div
                            class="card-header d-flex align-items-center justify-content-between"
                        >
                            <span style="font-size: 20px" v-if="userDetail !== null"
                                >{{ $t("lang.label_org_asgnd") }}
                                <b
                                    >{{ userDetail.firstname }}
                                    {{ userDetail.lastname }}</b
                                ></span
                            >
                            <div>
                                <button
                                    type="button"
                                    class="btn btn-success btn-sm"
                                    @click="actionAssignOrg"
                                    style="margin-right: 5px"
                                >
                                    <i class="fas fa-plus"></i>
                                    {{ $t("lang.label_asgn_new_org") }}
                                </button>
                                <router-link
                                    :to="{ name: 'Users' }"
                                    class="btn btn-info btn-sm mr-2"
                                    ><i class="fas fa-arrow-left"></i>
                                    {{ $t("lang.label_back") }}</router-link
                                >
                            </div>
                        </div>
                        <div class="card-body" style="padding-top: 0">
                            <div class="row">
                                <div class="col-md-6 offset-3">
                                    <div style="margin-bottom: 80px">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="80%">
                                                        {{ $t("lang.label_org") }}
                                                    </th>
                                                    <th scope="col">
                                                        {{ $t("lang.label_action") }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(i, index) in orgsAssign"
                                                    :key="index"
                                                >
                                                    <td width="80%">
                                                        {{ i.bill_company_name }}
                                                    </td>
                                                    <td>
                                                        <span class="cdropdown">
                                                            <button>
                                                                <span
                                                                    ><i
                                                                        class="fa fa-cog"
                                                                    ></i
                                                                ></span>
                                                            </button>
                                                            <label>
                                                                <input type="checkbox" />
                                                                <ul>
                                                                    <li
                                                                        @click="
                                                                            AppsAvailablesByOrg(
                                                                                i.org_id
                                                                            )
                                                                        "
                                                                    >
                                                                        <button>
                                                                            <i
                                                                                class="fas fa-eye"
                                                                            ></i>
                                                                            {{
                                                                                $t(
                                                                                    "lang.label_asgn_priv"
                                                                                )
                                                                            }}
                                                                        </button>
                                                                    </li>
                                                                    <!--    <li @click="privilegesOrg(i.id,i.user_id)"><button><i class="fas fa-edit"></i> Privileges</button></li> -->
                                                                    <li
                                                                        @click="
                                                                            delOrg(
                                                                                i.id,
                                                                                i.user_id
                                                                            )
                                                                        "
                                                                    >
                                                                        <button>
                                                                            <i
                                                                                class="fas fa-times"
                                                                            ></i>
                                                                            {{
                                                                                $t(
                                                                                    "lang.label_del"
                                                                                )
                                                                            }}
                                                                        </button>
                                                                    </li>
                                                                </ul>
                                                            </label>
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal
            name="org-assign"
            height="auto"
            :width="400"
            @before-close="getOrganizations2"
        >
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">{{ $t("lang.label_asgn_org") }}</h5>
                    <form @submit.prevent="MetAssignOrg">
                        <div class="row">
                            <div class="col-9">
                                <label for="inputEmail4"
                                    >{{ $t("lang.label_name_org") }}:</label
                                >
                                <select
                                    id="inputState"
                                    class="form-control"
                                    v-model="modal.org_id"
                                >
                                    <option
                                        :value="i.id"
                                        v-for="i in orgsDisponibles"
                                        :key="i.id"
                                    >
                                        {{ i.bill_company_name }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-3">
                                <label for="inputEmail4" style="display: block"
                                    ><span style="color: #5198d4">.</span></label
                                >
                                <button class="btn btn-success" type="submit">
                                    {{ $t("lang.label_save") }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </modal>
        <modal name="apps-users" height="auto" :width="300">
            <div class="card">
                <div class="card-body">
                    <div class="bgloading" v-if="isLoading"><Loader></Loader></div>
                    <h5 class="card-title">{{ $t("lang.label_edit_priv") }}</h5>
                    <div class="row">
                        <div class="col-12">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" width="90%">
                                            {{ $t("lang.label_name_app") }}
                                        </th>
                                        <th scope="col" width="10%">
                                            {{ $t("lang.label_action") }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(i, index) in appslistbyorg"
                                        :key="index"
                                        v-if="appslistbyorg.length > 0"
                                    >
                                        <td>{{ i.name }}</td>
                                        <td>
                                            <button
                                                type="button"
                                                class="btn btn-primary btn-sm"
                                                @click="AssignPrivilegies(i.id)"
                                            >
                                                {{ $t("lang.label_priv") }}
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="appslistbyorg.length === 0">
                                        <td colspan="2">
                                            <div>
                                                {{ $t("lang.msj_org_apps_intled") }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </Default-Layout>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Loader from "@/components/shared/Loader";
import DefaultLayout from "@/Layouts/Account/DefaultLayout";
export default {
    name: "Privilegies",
    components: {
        Loader,
        DefaultLayout,
    },
    data () {
        return {
            isloading: false,
            userDetail: null,
            organizationslist: [],
            orgsDisponibles: [],
            orgsAssign: [],
            modal: {
                action: "create",
                org_id: window.localorgdata,
                user_id_secondary: null,
            },
            orgAssignByUser: [],
            appslistbyorg: [],
            orgIdCurrent: null,
        }
    },
    created () {
        if (window.user_type == 2) {
            this.$router.push({ name: "Home" });
        }
        this.getOrganizations2();
    },
    mounted () {
        if (this.$route.params.account_id) {
            this.usersById(this.$route.params.account_id);
        }
    },
    methods: {
        AssignPrivilegies(app_id) {
            console.log("app_id=" + app_id);
            console.log("org_id " + this.orgIdCurrent);
            console.log("user_id " + this.$route.params.account_id);
            const userId = this.$route.params.account_id;
            this.$router.push({
                name: "PrivilegiesList",
                params: { account_id: userId, org_id: this.orgIdCurrent, app_id: app_id },
            });
        },
        delOrg(id, user_id) {
            window.master
                .get("user/assignorg/delete/" + id + "/" + user_id)
                .then((response) => {
                    if (response.data.status) {
                        this.usersById(this.$route.params.account_id);
                        this.$swal.fire({
                            type: "success",
                            title: window.lang2.label_deld,
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    }
                })
                .catch((error) => console.log(error));
        },
        getOrganizations2() {
            console.log("org all inicio");
            this.isloading = true;
            window.master
                .get("organizationall/" + window.localAccountID)
                .then((response) => {
                    this.organizationslist = response.data.result;
                    this.isloading = false;
                })
                .catch((error) => console.log(error));
        },
        usersById(account_id) {
            window.master
                .get("user/" + window.localAccountID + "/" + account_id)
                .then((response) => {
                    let listOrs = this.organizationslist;
                    this.userDetail = response.data.user_detail;
                    this.orgsAssign = response.data.result;
                    this.isloading = false;
                })
                .catch((error) => console.log(error));
        },
        AppsAvailablesByOrg(org_id) {
            this.orgIdCurrent = org_id;
            this.$modal.show("apps-users");
            this.isloading = true;
            window.master
                .get("getapp/" + org_id)
                .then((response) => {
                    console.log("apps lista" + response.data);
                    this.isloading = false;
                    this.appslistbyorg = response.data.r;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        MetAssignOrg() {
            if (this.modal.action == "create") {
                window.master
                    .post("user/assignorg", {
                        user_id: window.localAccountID,
                        org_id: this.modal.org_id,
                        user_id_secondary: this.$route.params.account_id,
                    })
                    .then((response) => {
                        if (this.$route.params.account_id) {
                            this.usersById(this.$route.params.account_id);
                        }
                        this.$modal.hide("org-assign");

                        if (response.data.status) {
                            this.$swal.fire({
                                type: "success",
                                title: window.lang2.label_org_asgnd_sful,
                                showConfirmButton: false,
                                timer: 2000,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },

        actionAssignOrg() {
            this.$modal.show("org-assign");
            let listOrs = this.organizationslist;
            this.orgsDisponibles = listOrs;
            if (this.orgsAssign.length > 0) {
                for (let i in this.orgsAssign) {
                    for (let e in this.organizationslist) {
                        if (this.orgsAssign[i].org_id == this.orgsDisponibles[e].id) {
                            this.orgsDisponibles.splice(e, 1);
                        }
                    }
                }
            }
        },
    },
}
</script>

<style scope="scss">
.icontri {
    position: absolute;
    top: -21px;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid #a1e0ae;
    transform: translateX(-50%);
}
.prof_title {
    display: block;
    font-size: 14px;
}
.prof_title h4 {
    font-weight: 100;
    font-size: 24px;
    text-align: center;
}
.profile {
    margin-top: 60px;
}
.profile label {
    display: block;
    margin-bottom: 0.1rem;
}
span.avatarDefault {
    width: 68px;
    height: 70px;
    display: flex;
    margin: 0px auto;
    border: 1px solid #ccc;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 30px;
    font-weight: 900;
    background-color: #5ac146;
    color: #fff;
}
img#avatar {
    height: 70px;
    width: 66px;
    border: 1px solid #ccc;
    border-radius: 50%;
}
</style>
